import { createUseStyles } from 'react-jss'

export const useStyle = createUseStyles({
  featuresRow: {
    textAlign: 'left',
    columnGap: 8
  }
})
